/* Install once in the Shopify theme head, with data-validation-url pointing to
 * the deployed /api/storefront/meta-attribution endpoint. No Meta token belongs here. */
(function () {
  "use strict";
  if (window.seinoMetaAcquisition) return;
  var endpoint = document.currentScript && document.currentScript.dataset.validationUrl;
  if (!endpoint) return;
  var storageKey = "seino_meta_acquisition_v1";
  var attribute = "seino_acquisition_meta_ad_id__";
  var evidenceAttribute = "seino_acquisition_evidence__";
  var property = "_seino_acquisition_meta_ad_id";
  var evidenceProperty = "_seino_acquisition_evidence";
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  var nativeFetch = window.fetch.bind(window);
  var memory = null;
  var inFlight = null;
  var cartSaved = false;

  function read() {
    var raw;
    try { raw = localStorage.getItem(storageKey); } catch (_) { /* Cookie fallback. */ }
    if (!raw) {
      var cookie = document.cookie.split("; ").find(function (c) { return c.startsWith(storageKey + "="); });
      try { raw = cookie ? decodeURIComponent(cookie.slice(storageKey.length + 1)) : null; } catch (_) { /* Ignore malformed cookie. */ }
    }
    try {
      var saved = raw ? JSON.parse(raw) : memory;
      return saved && saved.version === 1 && /^[1-9]\d{5,24}$/.test(saved.adId) ? saved : null;
    } catch (_) { return memory; }
  }
  function persist(value) {
    // First validated record wins, including another tab's earlier capture.
    var existing = read();
    memory = existing || value;
    try { localStorage.setItem(storageKey, JSON.stringify(memory)); } catch (_) { /* Cookie remains available. */ }
    document.cookie = storageKey + "=" + encodeURIComponent(JSON.stringify(memory)) + "; Path=/; Max-Age=31536000; SameSite=Lax; Secure";
    return memory;
  }
  function attributes(record) {
    var values = {};
    values[attribute] = record.adId;
    values[evidenceAttribute] = JSON.stringify(record);
    return values;
  }
  async function saveCart() {
    var record = read();
    if (!record || cartSaved) return;
    if (inFlight) return inFlight;
    inFlight = nativeFetch(root + "cart/update.js", { method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: attributes(record) }),
      signal: AbortSignal.timeout(4000) }).then(function (response) {
        if (!response.ok) throw new Error("Attribution cart write failed");
        cartSaved = true;
      }).catch(function () { /* Retry on the next cart/checkout action; never break purchasing. */ })
      .finally(function () { inFlight = null; });
    return inFlight;
  }
  function decorate(form) {
    var record = read();
    if (!record) return;
    var action = new URL(form.action || location.href, location.href).pathname;
    var add = /\/cart\/add(?:\.js)?$/.test(action);
    if (!add && !/\/cart$/.test(action)) return;
    var values = add ? {} : attributes(record);
    if (add) { values[property] = record.adId; values[evidenceProperty] = JSON.stringify(record); }
    Object.keys(values).forEach(function (key) {
      var name = (add ? "properties" : "attributes") + "[" + key + "]";
      var input = Array.from(form.elements).find(function (el) { return el.name === name; });
      if (!input) { input = document.createElement("input"); input.type = "hidden"; input.name = name; form.appendChild(input); }
      input.value = values[key];
    });
  }
  function decorateAll() { document.querySelectorAll("form").forEach(decorate); }
  var params = new URLSearchParams(location.search);
  var candidates = [].concat(params.getAll("tw_adid"), params.getAll("fbadid"));
  var capturedAt = new Date().toISOString();
  var pendingKey = storageKey + "_pending";
  var queue = [];
  try { queue = JSON.parse(sessionStorage.getItem(pendingKey) || "[]"); } catch (_) { /* In-memory queue remains available. */ }
  if (!Array.isArray(queue)) queue = [];
  if (candidates.length && candidates.length <= 4) queue.push({ parameters: candidates,
    capturedAt: capturedAt, landingPage: location.origin + location.pathname });
  queue = queue.slice(0, 10);
  function saveQueue() { try { sessionStorage.setItem(pendingKey, JSON.stringify(queue)); } catch (_) { /* No durable pending queue. */ } }
  saveQueue();
  async function performCapture() {
    if (read()) { decorateAll(); await saveCart(); return; }
    while (queue.length) {
      var landing = queue[0];
      var ids = Array.isArray(landing.parameters) ? landing.parameters.filter(function (id) {
        return typeof id === "string" && /^[1-9]\d{5,24}$/.test(id);
      }) : [];
      if (!ids.length || ids.length > 4) { queue.shift(); saveQueue(); continue; }
      try {
        var url = new URL(endpoint);
        ids.forEach(function (id) { url.searchParams.append("id", id); });
        var response = await nativeFetch(url.toString(), { credentials: "omit", signal: AbortSignal.timeout(4000) });
        if (!response.ok) return;
        var result = await response.json();
        if (result.status === "unavailable") return;
        if (result.status !== "verified" || !ids.includes(result.adId)) { queue.shift(); saveQueue(); continue; }
        var store = function () { return persist({ version: 1, adId: result.adId, capturedAt: landing.capturedAt,
          validatedAt: new Date().toISOString(), landingPage: landing.landingPage,
          parameters: ids }); };
        if (navigator.locks) await navigator.locks.request(storageKey, store); else store();
        queue = []; saveQueue();
        decorateAll();
        await saveCart();
        return;
      } catch (_) { return; /* Keep unverified candidates for the next page or online event. */ }
    }
  }

  var activeCapture = null;
  function capture() {
    if (!activeCapture) activeCapture = performCapture().finally(function () { activeCapture = null; });
    return activeCapture;
  }
  var captureTask = capture();
  // Theme Ajax add-to-cart flows can serialize without submitting a form.
  // Attach private line properties and finish the cart write before callers
  // navigate to checkout. Non-cart requests are left untouched.
  window.fetch = async function (input, options) {
    var requestUrl = new URL(typeof input === "string" ? input : input.url || String(input), location.href);
    if (requestUrl.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(requestUrl.pathname)) {
      return nativeFetch(input, options);
    }
    await captureTask;
    var record = read();
    var next = options ? Object.assign({}, options) : {};
    if (record && next.body) {
      if (next.body instanceof FormData || next.body instanceof URLSearchParams) {
        next.body.set("properties[" + property + "]", record.adId);
        next.body.set("properties[" + evidenceProperty + "]", JSON.stringify(record));
      } else if (typeof next.body === "string") {
        try {
          var body = JSON.parse(next.body);
          (body.items || [body]).forEach(function (item) {
            item.properties = Object.assign({}, item.properties);
            item.properties[property] = record.adId;
            item.properties[evidenceProperty] = JSON.stringify(record);
          });
          next.body = JSON.stringify(body);
        } catch (_) { /* Unknown encoding: cart attributes remain the fallback. */ }
      }
    }
    var response = await nativeFetch(input, next);
    if (response.ok) { cartSaved = false; await saveCart(); }
    return response;
  };
  // Capture-phase submit runs before theme handlers serialize product forms;
  // private line properties also cover product-page accelerated checkout.
  document.addEventListener("submit", function (event) { decorate(event.target); void saveCart(); }, true);
  document.addEventListener("click", function (event) {
    var target = event.target instanceof Element ? event.target.closest("a[href], button, input[type=submit]") : null;
    if (!target) return;
    decorateAll();
    var checkout = target.matches('[name="checkout"]') || (target.tagName === "A" && /\/checkout(?:[/?]|$)/.test(target.getAttribute("href") || ""));
    if (!checkout || target.dataset.seinoContinuing === "true") return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void Promise.race([captureTask.then(saveCart), new Promise(function (resolve) { setTimeout(resolve, 4500); })]).finally(function () {
      target.dataset.seinoContinuing = "true";
      target.click();
      delete target.dataset.seinoContinuing;
    });
  }, true);
  var observer = new MutationObserver(function (changes) {
    if (changes.some(function (c) { return Array.from(c.addedNodes).some(function (n) {
      return n.nodeType === 1 && (n.matches("form") || n.querySelector("form"));
    }); })) decorateAll();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", decorateAll);
  window.addEventListener("pageshow", function () { cartSaved = false; captureTask = capture(); });
  window.addEventListener("online", function () { captureTask = capture(); });
  window.addEventListener("storage", function (event) { if (event.key === storageKey) { cartSaved = false; decorateAll(); void saveCart(); } });
  window.seinoMetaAcquisition = { sync: function () { cartSaved = false; captureTask = capture(); return captureTask; } };
})();
